import {} from 'antd';
import Button from 'components/Button';
import DrawerComponent from 'components/Drawer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { routes } from 'routes/AllRoutes';
import { FarmerGroupV2 } from 'types/response';
import FarmerGroupContent from './FarmerGroupContent';
import ProtectedResource from 'components/RoleBasedAccessControl/ProtectedResource';

type FarmerGroupDrawerProps = {
  country: string;
  data?: FarmerGroupV2;
  open: boolean;
  onClose: () => void;
};

const FarmerGroupDetailDrawer = ({
  country,
  data,
  open,
  onClose,
}: FarmerGroupDrawerProps) => {
  const [activeKey, setActiveKey] = useState('1');

  const { t } = useTranslation();

  return (
    <DrawerComponent
      title={t('addFgForm.farmerGroupDetails')}
      open={open}
      onClose={() => {
        onClose();
        setActiveKey('1');
      }}
      extra={
        <ProtectedResource permission="farmer_group:edit">
          <Link to={routes.farmerGroupEdit.replace(':id', data?.id ?? '')}>
            <Button>Edit</Button>
          </Link>
        </ProtectedResource>
      }
      content={
        <FarmerGroupContent
          country={country}
          data={data}
          activeKey={activeKey}
          setActiveKey={setActiveKey}
        />
      }
    />
  );
};

export default FarmerGroupDetailDrawer;
